module.exports = __webpack_public_path__ + "static/media/logo-algolia-nebula-blue-full.5a7dd96a.png";